import type { ToastOptions } from "react-toastify";

export const OR_TOAST_DEFAULT_OPTIONS: ToastOptions = {
  autoClose: 4000,
  closeButton: false,
  closeOnClick: true,
  hideProgressBar: false,
  position: "top-right",
  theme: "light",
};
